// 야근 — 자리비움처럼 당일 건만 신청 → 시작/종료 버튼으로 실제 시각 기록.
// 예정 시작은 그날 18:00 이후, 예정 종료는 같은 날 밤 또는 다음 날 09:00 전.
export const OVERTIME_STATUS_LABELS = {
    planned: '야근예정', in_progress: '야근중', done: '야근완료', canceled: '취소',
};
const KST = '+09:00';
export const kstToday = (now = new Date()) => new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul' }).format(now);
const addDay = (date, n) => new Date(Date.parse(`${date}T00:00:00Z`) + n * 86400000).toISOString().slice(0, 10);
/**
 * 신청 시간 해석·검증 — 시작 HH:mm(18:00 이후), 종료 HH:mm(시작보다 늦으면 같은 날, 이르면 다음 날로 보고 09:00 전이어야 함).
 * 성공하면 ISO 시작·종료, 실패하면 사유.
 */
export function planOvertime(date, start, end, today = kstToday()) {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(date) || !/^\d{2}:\d{2}$/.test(start) || !/^\d{2}:\d{2}$/.test(end))
        return { error: '날짜·시간 형식이 올바르지 않습니다.' };
    if (date !== today)
        return { error: '야근은 당일 건만 신청할 수 있습니다.' };
    if (start < '18:00')
        return { error: '야근 시작 예정은 오후 6시 이후로 정해 주세요.' };
    const nextDay = end <= start;
    if (nextDay && end >= '09:00')
        return { error: '야근 종료 예정은 다음 날 오전 9시 전이어야 합니다.' };
    const planStart = new Date(`${date}T${start}:00${KST}`).toISOString();
    const planEnd = new Date(`${nextDay ? addDay(date, 1) : date}T${end}:00${KST}`).toISOString();
    return { planStart, planEnd };
}
/** 'HH:mm' (KST) */
export const kstHm = (iso) => iso ? new Intl.DateTimeFormat('sv-SE', { timeZone: 'Asia/Seoul', hour: '2-digit', minute: '2-digit', hour12: false }).format(new Date(iso)) : '';
/** 실제 야근 시간(분) — 종료 전이면 지금까지 */
export function overtimeMinutes(r, now = new Date()) {
    if (!r.actualStart)
        return 0;
    const end = r.actualEnd ? Date.parse(r.actualEnd) : now.getTime();
    return Math.max(0, Math.round((end - Date.parse(r.actualStart)) / 60000));
}
//# sourceMappingURL=overtime.js.map